import React from "react"
import {useTranslation} from "react-i18next"

// Components
import Kbd from "../../../../../components/modern/Kbd"

// Styles
import useStyles from "./styles"

/**
 * Keycap legend for the dashboard shortcuts. Presentational only — the actual
 * listener lives in ModernHomePage, which owns the state the shortcuts drive.
 *
 * Kept in sync with that listener by hand; if a shortcut is added there, add
 * its cap here too or the legend starts lying.
 */
export default function ModernPageKeys() {
    const styles = useStyles();
    const [t] = useTranslation("common");

    return (
      <div className={styles.pagekeys}>
          <span className={styles.hint}>
              <Kbd>/</Kbd> {t("modern.keys.search")}
          </span>
          <span className={styles.hint}>
              <Kbd>1</Kbd>–<Kbd>3</Kbd> {t("modern.keys.tabs")}
          </span>
          <span className={styles.hint}>
              <Kbd>D</Kbd> {t("modern.keys.reading_room")}
          </span>
          <span className={styles.hint}>
              <Kbd>Enter</Kbd> {t("modern.keys.open_top")}
          </span>
      </div>
    )
}
